import * as React from "react";
import { useTranslation } from 'react-i18next';
import { Routes, Route, useParams, useSearchParams } from "react-router-dom";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import AppContext from "../../utils/context";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { formatCell } from "../../components/autocell.js";
import '../../styles/table.css';

export default function PageTable() {
  const { t } = useTranslation();
  const appContext = React.useContext(AppContext);
  const [columns, setColumns] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [title, setTitle] = React.useState("");
  const [filters, setFilters] = React.useState({ items: [] });

  let { pageSlug } = useParams();

  React.useEffect(() => {
  if (!pageSlug) return;

  const load = async () => {
    const { data } = await appContext.database.rpc('get_table_page_data', {
      page_slug: pageSlug,
    });
    setRows(data.rows);
    setColumns(data.columns);
    setTitle(data.title);
  };

  load();
}, [pageSlug]);

  return (
    <div style={{flexGrow: 1, display: "flex", flexDirection: "column", minWidth: 0}}>
      <div className="wrapper" style={{ display: "flex", padding: "20px", minWidth: 0 }}>
        <Paper
          style={{ flexGrow: 1, display: "flex", flexDirection: "column", minWidth: 0 }}
        >
          <Box sx={{ padding: "10px", display: "flex", flexDirection: "row" }}>
            <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center", paddingY: 1 }}>
              <Breadcrumbs aria-label="breadcrumb">
                <Typography sx={{ color: 'text.primary' }}>{title}</Typography>
              </Breadcrumbs>
            </Box>
          </Box>
          {rows && columns && rows.length > 0 && (
            <DataGrid
              rows={rows}
              columns={[
                ...formatCell(columns)
              ]}
              initialState={{
                pagination: {
                  paginationModel: {
                    pservicesSize: 50,
                  },
                },
                sorting: {
                  sortModel: [{ field: "name", sort: "asc" }],
                },
              }}
              disableRowSelectionOnClick={true}
              disableMultipleRowSelection={true}
              disableColumnResize={true}
              filterModel={filters}
              onFilterModelChange={(model) => setFilters(model)}
              sx={{ border: "none", flexGrow: 1, minWidth: 0 }}
              disableSelectionOnClick
            />
          )}
        </Paper>
      </div>
    </div>
  );
}
